import type { HowItWorksStep } from "@/shared/ui/HowItWorks";

export const WIDGET_STEPS: HowItWorksStep[] = [
  {
    title: "Укажите партнёрский ID",
    text: "Он выдаётся в партнёрской программе. По нему оформленные полисы закрепляются за вами.",
  },
  {
    title: "Выберите продукт",
    text: "ОСАГО или ПКаско — от этого зависит, какая форма расчёта откроется у клиента.",
  },
  {
    title: "Настройте цвета под свой бренд",
    text: "Форма подстроится под сайт: фон, поля, кнопки и подписи. Изменения сразу видны в предпросмотре.",
  },
  {
    title: "Скопируйте код и вставьте на сайт",
    text: "Готовый фрагмент размещается в вёрстке страницы — виджет подгрузится сам.",
  },
];
